// extracted by mini-css-extract-plugin
export default {"error":"error_error__jhGha"};